module.exports = __webpack_public_path__ + "static/interview_1-24126fcb2eee1f55186d7885f05e32a9.m4a";